import React, { useState } from 'react';
import './ContactPage.css';
import { Mail, Phone, MapPin, Send, CheckCircle } from 'lucide-react';
import {toast} from 'react-hot-toast'
const API = process.env.REACT_APP_API_URL || "http://localhost:5000";

const ContactPage = () => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    inquiryType: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const res = await fetch(`${API}/api/contact`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    });

    if (res.ok) {
      toast.success("Message sent successfully! We will contact you soon.");

      setFormData({
        fullName: "",
        email: "",
        phone: "",
        inquiryType: "",
        message: "",
      });
    } else {
      toast.error("Failed to send message. Please try again.");
    }
  } catch (err) {
    console.error(err);
    toast.error("Something went wrong. Please try later.");
  }
};


  return (
    <div className="page-wrapper">
      <div className="contact-card">
        
        {/* Left Panel: Branding & Info */}
        <div className="info-panel">
          <div className="decorative-circle"></div>
          
          <div className="info-content">
            <h2 className="brand-title">Get in Touch</h2>
            <p className="brand-desc">
              We are here to assist with prescriptions, product details, or general inquiries. 
              Your health is our priority.
            </p>

            <div className="contact-details">
              <div className="detail-row">
                <div className="icon-box"><Phone size={18} /></div>
                <span>+91 7993813285</span>
              </div>
              <div className="detail-row">
                <div className="icon-box"><Mail size={18} /></div>
                <span>hellohiiii6666@gmail.com</span>
              </div>
              <div className="detail-row">
                <div className="icon-box"><MapPin size={18} /></div>
                <span>123 Health Blvd, Wellness City</span>
              </div>
            </div>
          </div>
          
          <div className="info-footer">
            <p>Mon-Fri: 8am - 8pm</p>
          </div>
        </div>

        {/* Right Panel: The Form */}
        <div className="form-panel">
            <>
              <div className="form-header">
                <h3>Send a Message</h3>
                <p>We typically reply within 2 hours.</p>
              </div>

              <form onSubmit={handleSubmit}>
                <div className="input-group">
                  <input 
                    type="text" 
                    name="fullName" 
                    required 
                    placeholder=" " 
                    value={formData.fullName}
                    onChange={handleChange}
                  />
                  <label>Full Name</label>
                </div>

                <div className="row">
                  <div className="input-group">
                    <input 
                      type="email" 
                      name="email" 
                      required 
                      placeholder=" " 
                      value={formData.email}
                      onChange={handleChange}
                    />
                    <label>Email Address</label>
                  </div>
                  <div className="input-group">
                    <input 
                      type="tel" 
                      name="phone" 
                      placeholder=" " 
                      value={formData.phone}
                      onChange={handleChange}
                    />
                    <label>Phone (Optional)</label>
                  </div>
                </div>

                <div className="input-group">
                  <select 
                    name="inquiryType" 
                    value={formData.inquiryType} 
                    onChange={handleChange}
                    required
                  >
                    <option value="" disabled hidden></option>
                    <option value="General">General Inquiry</option>
                    <option value="Order">Order Support</option>
                    <option value="Prescription">Prescription Help</option>
                  </select>
                  <label className="select-label">Subject</label>
                </div>

                <div className="input-group">
                  <textarea 
                    name="message" 
                    required 
                    placeholder=" " 
                    rows="4"
                    value={formData.message}
                    onChange={handleChange}
                  ></textarea>
                  <label>How can we help?</label>
                </div>

                <button type="submit" className="submit-btn" disabled={loading}>
                   {loading ? "Sending..." : "Send Message"} <Send size={16} />
                </button>

              </form>
            </>
          
        </div>

      </div>
    </div>
  );
};

export default ContactPage;